@if (history?.length > 0) {
  @for (item of history; track item; let isLast = $last) {
    <div class="grid-x">
      <div class="cell small-4 bold">{{item?.recordedDate | date: 'MM/dd/yyyy hh:mm a'}}</div>
      <div class="cell small-8 bold text-align-right">
        {{item?.recordedByName}}
      </div>
      <div class="cell small-12 padding-left" [innerHTML]="item?.eventTypeDescription"></div>
      @if (!isLast) {
        <div class="cell small-12">
          <hr />
        </div>
      }
    </div>
  }
} @else {
  <p>No recorded events.</p>
}
